export default __webpack_public_path__ + "static/media/notFound.10a3cb12.png";